import actionCreatorFactory from "typescript-fsa"
import { Auth } from "./types"

const actionCreator = actionCreatorFactory()

export const storeTokenAction = actionCreator<Auth>("STORE_TOKEN")
